import Divider from '@amzn/meridian/divider';
import RadioButton from '@amzn/meridian/radio-button';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import React, { ReactNode } from 'react';
import { ErrorRecord } from 'src/hooks/useForm';
import { DownloadTWPAForm } from 'src/store/placementDetailsPageSlice/types';

interface RadioOption {
  value: any;
  label: ReactNode;
}

interface RadioFieldsProps {
  textInfo: ReactNode;
  formDataKey: keyof DownloadTWPAForm;
  radioOptions: RadioOption[];
  twpaFormData: Partial<DownloadTWPAForm>;
  twpaFormErrors: ErrorRecord<DownloadTWPAForm>;
  handleChange: (key: keyof DownloadTWPAForm, value: any) => void;
}

/**
 * Default Component
 */
const RadioFields = ({
  textInfo,
  radioOptions,
  formDataKey,
  twpaFormData,
  twpaFormErrors,
  handleChange,
}: RadioFieldsProps) => {
  const getErrorText = (formDataKey: keyof DownloadTWPAForm) => {
    if (twpaFormErrors[formDataKey]?.error) {
      return twpaFormErrors[formDataKey]?.errorMessage;
    }
    return '';
  };

  return (
    <div>
      <Text>{textInfo || ''}</Text>
      <Text color="error">{getErrorText(formDataKey)}</Text>

      {radioOptions.map((radioOption, index) => (
        <Row key={`${index}-${radioOption.value}`} widths={['fill']} spacingInset="200">
          <RadioButton
            checked={twpaFormData[formDataKey] === radioOption.value}
            onChange={(value) => handleChange(formDataKey, value)}
            value={radioOption.value}
            aria-label={radioOption.label}
          >
            {radioOption.label}
          </RadioButton>
        </Row>
      ))}

      <Divider spacingBefore="400" spacingAfter="400" />
    </div>
  );
};

export default RadioFields;
